class IconSet {
}
IconSet.schema = {
    "type": "object",
    "properties": {}
}
export default IconSet;